var _rect, _circle, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementStaplesLandscapeLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 45,
    height: 60,
    rx: 2,
    transform: "rotate(90 60 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 22.5,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.804 29.5H36.828V21.772C36.828 19.868 36.828 15.724 31.088 15.724C28.96 15.724 26.86 16.368 25.376 17.88L27.14 19.644C28.036 18.804 29.324 18.244 30.724 18.244C32.516 18.244 33.804 19.112 33.804 20.764V21.128H32.964C29.604 21.128 24.508 21.436 24.508 25.804C24.508 28.464 26.916 29.836 29.408 29.836C31.2 29.836 32.768 29.164 33.72 27.652H33.804V29.5ZM33.608 24.236C33.608 26.112 32.516 27.316 30.22 27.316C29.128 27.316 27.868 26.784 27.868 25.552C27.868 23.62 31.06 23.48 32.908 23.48H33.608V24.236Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 6.5,
    width: 1.5,
    height: 8,
    rx: 0.75,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 29.5,
    width: 1.5,
    height: 8,
    rx: 0.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementStaplesLandscapeLength);
export default __webpack_public_path__ + "static/media/placement-staples-landscape-length.6fa9128a6752fd0c044a6829bdcc9715.svg";
export { ForwardRef as ReactComponent };